import React, { useState, useRef } from 'react';
import { IoCloudUploadOutline } from 'react-icons/io5';
import { MdOutlineFileCopy } from "react-icons/md";
import { FaRegFileArchive } from "react-icons/fa";
import { LuFileVideo2 } from "react-icons/lu";
import { CiImageOn } from "react-icons/ci";

const UploadFile = ({ initialFile, onFileSelect, height, type = "image" }) => {
    // 1. Define configurations for different types
    const typeConfig = {
        video: {
            icon: <LuFileVideo2 />,
            accept: "video/*",
            label: "Video"
        },
        document: {
            icon: <MdOutlineFileCopy />,
            accept: ".pdf,.doc,.docx,.txt",
            label: "Document"
        },
        zip: {
            icon: <FaRegFileArchive />,
            accept: ".zip,.rar,.7z",
            label: "Zip File"
        },
        image: {
            icon: <CiImageOn />,
            accept: "image/*",
            label: "Image"
        }
    };

    // Fallback to image if the type provided doesn't exist
    const currentConfig = typeConfig[type] || typeConfig.image;

    const [fileName, setFileName] = useState(initialFile?.name || null);
    const [preview, setPreview] = useState(null); // Used only for images
    const fileInputRef = useRef(null);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFileName(file.name);
            
            // Create a preview only if it's an image
            if (file.type.startsWith('image/')) {
                setPreview(URL.createObjectURL(file));
            } else {
                setPreview(null);
            }

            onFileSelect(file);
        }
    };

    const handleCancel = () => {
        setFileName(null);
        setPreview(null);
        onFileSelect(null);
        if (fileInputRef.current) fileInputRef.current.value = "";
    };

    const triggerPicker = () => {
        fileInputRef.current.click();
    };

    return (
        <div className="upload_cover" style={height ? { height: height } : null}>
            <input
                type="file"
                ref={fileInputRef}
                onChange={handleFileChange}
                style={{ display: 'none' }}
                accept={currentConfig.accept}
            />

            <div className="upload_contain" style={{ textAlign: 'center' }}>
                {fileName ? (
                    <>
                        {/* Display image preview OR the type-specific icon */}
                        {preview ? (
                            <img src={preview} alt="preview" style={{ width: '50px', height: '50px', objectFit: 'cover' }} />
                        ) : (
                            currentConfig.icon
                        )}
                        
                        <p style={{fontSize: '12px', margin: '5px 0'}}>{fileName}</p>
                        
                        <div className="button_group">
                            <button onClick={triggerPicker}>Re-Upload</button>
                            <button onClick={handleCancel} style={{ border: "none", color: 'red' }}>Cancel</button>
                        </div>
                    </>
                ) : (
                    <>
                        <div style={{fontSize: '2rem'}}>{currentConfig.icon}</div>
                        <button onClick={triggerPicker}>Upload {currentConfig.label}</button>
                    </>
                )}
            </div>
        </div>
    );
};

export default UploadFile;